var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import EventBus from '@EventBus';
import { loaded } from 'vue2-google-maps';
import { mapGetters } from 'vuex';
import { LOCATION, FRANCHISOR, APP_STORE } from '@/stores/defs';
import { filter } from 'lodash';
var mapsMixin = {
    data: function () {
        return {
            googleLoaded: false
        };
    },
    computed: __assign({}, mapGetters({
        currentLocation: LOCATION.GET_LOCATION,
        franchisor: FRANCHISOR.GET_FRANCHISOR,
        getLocations: LOCATION.GET_LOCATIONS,
        appLoaded: APP_STORE.LOADED,
        getGmapAPIKey: APP_STORE.GET_GMAP_API,
    }), { 
        // TODO removed localized reference, only use store reference
        googleMapsApiKey: function () {
            if (this.currentLocation.id && this.currentLocation.delivery) {
                return this.currentLocation.delivery.googleMapsApiKey;
            }
            else if (this.franchisor.deliveryFlowModel) {
                return this.franchisor.deliveryFlowModel.googleMapsApiKey;
            }
            else {
                return false;
            }
        } }),
    methods: {
        searchByName: function (locations) {
            if (locations === void 0) { locations = null; }
            var useLocations = locations || this.getLocations;
            var el = this.$el;
            var searchField = el.querySelector('#store-name-field');
            var searchTerm = searchField.value;
            var searchLocations = filter(useLocations, function (storeLocation) {
                var haystack = storeLocation.address + ' ' + storeLocation.name + ' ' + storeLocation.locality;
                if (haystack.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1) {
                    return true;
                }
                return false;
            });
            EventBus.$emit('updateSearchLocations', searchLocations);
        },
        _initMap: function () {
            var _this = this;
            loaded.then(function () {
                _this.googleLoaded = true;
            });
        }
    },
    created: function () {
        this._initMap();
    }
};
export default mapsMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/mapsMixin.ts
// module id = Nf2x
// module chunks = 18